import * as React from "react";

const TundishTrackSvg = (props: any) => (
	<svg
		width={375}
		height={166}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g filter="url(#a)">
			<rect
				x={16.618}
				y={16}
				width={341.752}
				height={133.232}
				rx={8}
				fill="#fff"
			/>
			<path
				d="m51.985 92.211 8.739-14.246c1.253-2.042 4.208-2.076 5.507-.063a3.254 3.254 0 0 1-.026 3.57l-2.777 4.164 11.533 19.737h-8.515l-6.78-13.202-2.218 3.464a3.224 3.224 0 0 1-2.715 1.486c-2.52 0-4.066-2.762-2.748-4.91Z"
				fill="url(#b)"
			/>
			<path
				d="m61.003 53.919 9.163 14.936c1.382 2.253-.24 5.148-2.881 5.148a3.38 3.38 0 0 1-2.848-1.558l-2.324-3.632-9.417 13.842h-.071L44.53 96.29l-.932 1.527-4.27 6.528h-5.192a1.516 1.516 0 0 1-1.303-2.292l24.411-39.11c.198-.331.429-.623.685-.876l-2.673-4.472a3.411 3.411 0 0 1-.028-3.742c1.362-2.11 4.46-2.075 5.774.066Z"
				fill="url(#c)"
			/>
			<path
				d="M97.017 72.185h-8.563v-4.261h22.28v4.261h-8.563v24.106h-5.154V72.185ZM117.761 96.9c-2.625 0-4.586-.703-5.885-2.11-1.298-1.434-1.948-3.328-1.948-5.682V76.812h5.114v11.81c0 2.84 1.325 4.26 3.977 4.26 1.163 0 2.259-.27 3.287-.811 1.028-.568 1.894-1.407 2.597-2.516V76.812h5.114v19.48h-4.951v-2.639c-.92 1.11-2.016 1.935-3.288 2.476-1.271.514-2.61.771-4.017.771Zm17.14-20.088h4.951v2.638c.92-1.11 2.016-1.921 3.287-2.435a10.158 10.158 0 0 1 4.018-.812c2.624 0 4.586.717 5.884 2.15 1.299 1.408 1.948 3.288 1.948 5.642V96.29h-5.113v-11.81c0-2.84-1.326-4.26-3.977-4.26a6.69 6.69 0 0 0-3.287.852c-1.029.54-1.894 1.366-2.598 2.475v12.743h-5.113v-19.48ZM169.126 96.9c-1.975 0-3.747-.42-5.316-1.258a9.551 9.551 0 0 1-3.652-3.612c-.866-1.569-1.299-3.382-1.299-5.438 0-2.029.433-3.828 1.299-5.397.892-1.57 2.11-2.787 3.652-3.653 1.569-.893 3.341-1.34 5.316-1.34 3.193 0 5.709.84 7.549 2.517V66.301h5.113v29.99h-4.951V94.02c-1.109 1.028-2.259 1.772-3.449 2.232-1.191.433-2.611.65-4.262.65Zm1.258-4.018c1.461 0 2.76-.392 3.896-1.177 1.137-.784 1.935-1.84 2.395-3.165v-3.937a5.945 5.945 0 0 0-2.395-3.165c-1.136-.812-2.435-1.217-3.896-1.217-1.839 0-3.354.595-4.545 1.785-1.19 1.19-1.785 2.72-1.785 4.586 0 1.867.595 3.382 1.785 4.545 1.191 1.164 2.706 1.745 4.545 1.745Zm19.157-19.48c-.812 0-1.502-.27-2.07-.81-.541-.542-.811-1.218-.811-2.03 0-.812.27-1.488.811-2.03a2.818 2.818 0 0 1 2.07-.852c.812 0 1.502.285 2.07.853.568.54.852 1.217.852 2.029 0 .812-.284 1.488-.852 2.03-.568.54-1.258.81-2.07.81Zm-2.597 3.41h5.194v19.48h-5.194v-19.48ZM204.91 96.9c-1.407 0-2.909-.162-4.505-.487-1.596-.325-2.841-.771-3.734-1.34v-4.341c1.055.649 2.313 1.176 3.774 1.582 1.461.379 2.841.568 4.14.568 1.299 0 2.245-.108 2.841-.324.595-.244.892-.677.892-1.299 0-.487-.162-.88-.487-1.177-.297-.325-.798-.608-1.501-.852-.676-.27-1.732-.595-3.166-.974-1.623-.46-2.908-.933-3.855-1.42-.92-.487-1.623-1.096-2.11-1.827-.46-.757-.69-1.731-.69-2.922 0-1.948.771-3.409 2.313-4.383 1.542-1 3.626-1.501 6.25-1.501 1.353 0 2.692.135 4.018.406 1.352.243 2.407.595 3.165 1.055v4.18c-.812-.487-1.799-.88-2.963-1.177a14.346 14.346 0 0 0-3.571-.446c-1.326 0-2.327.135-3.003.405-.676.244-1.015.73-1.015 1.461 0 .487.176.88.528 1.177.379.27.866.514 1.461.73.595.19 1.677.488 3.247.894 1.677.46 2.989.96 3.936 1.501.947.541 1.623 1.19 2.029 1.948.406.758.609 1.705.609 2.84 0 1.732-.744 3.126-2.232 4.181-1.461 1.028-3.585 1.542-6.371 1.542Zm12.662-30.6h5.114v12.987c1.839-2.056 4.22-3.084 7.142-3.084 2.625 0 4.586.717 5.885 2.15 1.298 1.408 1.948 3.288 1.948 5.642V96.29h-5.114v-11.81c0-2.84-1.325-4.26-3.977-4.26a6.693 6.693 0 0 0-3.287.852c-1.028.54-1.894 1.366-2.597 2.475v12.743h-5.114v-29.99Zm27.429 5.885h-8.562v-4.261h22.279v4.261h-8.563v24.106h-5.154V72.185Zm13.907 4.627h4.951v3.124c.785-1.055 1.894-1.84 3.328-2.353 1.461-.514 3.125-.771 4.992-.771v3.896c-1.975 0-3.693.31-5.154.933-1.434.595-2.435 1.542-3.004 2.84v11.81h-5.113v-19.48ZM280.754 96.9c-2.327 0-4.234-.609-5.722-1.826-1.488-1.245-2.232-2.909-2.232-4.992 0-2.164.703-3.855 2.11-5.073 1.407-1.217 3.382-1.826 5.925-1.826 2.462 0 4.586.5 6.372 1.502v-.528c0-1.38-.433-2.38-1.299-3.003-.839-.622-2.205-.933-4.099-.933-1.19 0-2.367.121-3.531.365-1.163.216-2.191.527-3.084.933v-4.017c.812-.38 1.894-.69 3.247-.934a22.879 22.879 0 0 1 3.977-.365c3.382 0 5.884.73 7.508 2.191 1.623 1.434 2.435 3.436 2.435 6.007v11.89h-4.83v-1.907a8.815 8.815 0 0 1-2.881 1.867c-1.055.433-2.354.65-3.896.65Zm1.258-3.734c1.136 0 2.164-.216 3.084-.649.92-.46 1.624-1.082 2.111-1.867V88.5c-1.488-1.056-3.193-1.583-5.114-1.583-2.732 0-4.099 1.055-4.099 3.165 0 1.028.338 1.8 1.015 2.313.703.514 1.704.772 3.003.772Zm24.821 3.734c-2.273 0-4.275-.406-6.006-1.217-1.705-.812-3.03-1.989-3.977-3.531-.947-1.542-1.421-3.395-1.421-5.56 0-2.164.474-4.018 1.421-5.56.974-1.569 2.313-2.76 4.017-3.571 1.732-.839 3.748-1.258 6.047-1.258 3.03 0 5.452.595 7.264 1.786v4.098c-1.758-1.244-4.004-1.866-6.736-1.866-2.083 0-3.747.527-4.992 1.582-1.217 1.028-1.826 2.625-1.826 4.79 0 2.136.609 3.72 1.826 4.747 1.245 1.028 2.881 1.542 4.911 1.542 2.732 0 5.086-.649 7.061-1.948v4.059c-.974.649-2.083 1.123-3.328 1.42-1.217.325-2.638.487-4.261.487Zm11.641-30.6h5.114v19.075l7.751-8.563h6.006l-8.684 9.537 9.658 9.942h-6.006l-8.725-9.009v9.01h-5.114V66.3Z"
				fill="url(#d)"
			/>
		</g>
		<defs>
			<linearGradient
				id="b"
				x1={55.184}
				y1={97.638}
				x2={66.505}
				y2={78.112}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#23BDDF" />
				<stop offset={1} stopColor="#6C5CE7" />
			</linearGradient>
			<linearGradient
				id="c"
				x1={41.712}
				y1={91.691}
				x2={61.191}
				y2={61.625}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#23BDDF" />
				<stop offset={1} stopColor="#6C5CE7" />
			</linearGradient>
			<linearGradient
				id="d"
				x1={148.521}
				y1={98.197}
				x2={154.059}
				y2={49.087}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#23BDDF" />
				<stop offset={1} stopColor="#6C5CE7" />
			</linearGradient>
			<filter
				id="a"
				x={0.618}
				y={0}
				width={373.752}
				height={165.232}
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation={8} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.216667 0 0 0 0 0.216667 0 0 0 0 0.216667 0 0 0 0.08 0" />
				<feBlend
					in2="BackgroundImageFix"
					result="effect1_dropShadow_1839_68453"
				/>
				<feBlend
					in="SourceGraphic"
					in2="effect1_dropShadow_1839_68453"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);

export default TundishTrackSvg;
